import PropTypes from "prop-types";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";

/**
 * V2PageHeader
 *
 * Full-width header bar for v2 pages. Title on the left (large), optional
 * controls slot on the far right. Sits inside the page body (below DashboardNavbar),
 * so the navbar keeps its sidenav toggle without carrying any selectors.
 *
 * Usage:
 *   <V2PageHeader title="LinkedIn Watch">
 *     <CompetitorSelector />
 *   </V2PageHeader>
 *
 * For pages with no right-side controls (Press Digest), omit children.
 */
function V2PageHeader({ title, subtitle, children }) {
  return (
    <VuiBox
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={2}
      mb={3}
    >
      {/* Left: title + optional subtitle */}
      <VuiBox>
        <VuiTypography
          variant="h4"
          color="white"
          fontWeight="bold"
          sx={{ lineHeight: 1.2 }}
        >
          {title}
        </VuiTypography>
        {subtitle && (
          <VuiTypography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.38)", fontSize: "0.78rem", mt: 0.25, display: "block" }}
          >
            {subtitle}
          </VuiTypography>
        )}
      </VuiBox>

      {/* Right: selectors / actions */}
      {children && (
        <VuiBox display="flex" alignItems="center" gap={1.5} flexShrink={0}>
          {children}
        </VuiBox>
      )}
    </VuiBox>
  );
}

V2PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

V2PageHeader.defaultProps = {
  subtitle: null,
  children: null,
};

export default V2PageHeader;
